export default "__VITE_ASSET__2cc8e2b7__"